import {MantineProvider} from "@mantine/core";
import "@mantine/core/styles.css";
import {Notifications} from "@mantine/notifications";
import "@mantine/notifications/styles.css";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import {Links, Meta, Scripts, ScrollRestoration} from "react-router";
import {Footer} from "~/components/footer";
import {Header} from "~/components/header";
import {LeadGenBlock} from "~/components/leadGenBlock";
import "~/styles/tailwind.css";

export function Layout({children}: {children: React.ReactNode}) {
    const queryClient = new QueryClient();

    return (
        <html
            lang="en"
            data-theme="light"
            style={{background: "#f7f7f7"}}
        >
            <head>
                <meta charSet="utf-8" />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                />
                <Meta />
                <Links />
            </head>
            <body
                className="bg-surface-primary-background text-text-primary"
                style={{fontFamily: '"IBM Plex Sans", sans-serif', background: "#f7f7f7", color: "#1a1d2e"}}
            >
                <MantineProvider theme={{primaryColor: "blue", fontFamily: '"IBM Plex Sans", sans-serif'}}>
                    <Notifications
                        position="top-right"
                        autoClose={5000}
                        zIndex={1000}
                    />
                    <QueryClientProvider client={queryClient}>
                        <ReactQueryDevtools initialIsOpen={false} />
                        <div className="min-h-screen flex flex-col">
                            <Header />
                            <main className="flex-1">{children}</main>
                            <LeadGenBlock className="gj-px-screen-edge-constrained gj-py-section-divider" />
                            <Footer />
                        </div>
                    </QueryClientProvider>
                    <ScrollRestoration />
                    <Scripts />
                </MantineProvider>
            </body>
        </html>
    );
}
